export default __webpack_public_path__ + "static/media/Doosan Robotics.134e3262.png";